import { NervaUserData } from 'hydra-data-types';
import { PapScreenName } from '../../../config/FlowTypes';

export enum PapTier {
  Standard = 'Standard',
  Moderate = 'Moderate',
  Full = 'Full',
}

export type PapScoreResult = {
  score: number;
  tier: PapTier;
};

export const HARDSHIP_NONE = 'None of the above';

export function calculatePapScore(userData: NervaUserData, isNonReferred = false): PapScoreResult {
  let score = 0;

  // Q1: Public Assistance
  const publicAssistance = userData[PapScreenName.PapPublicAssistance]?.[0];
  if (publicAssistance === 'yes') {
    score += 3;
  }

  // Q2: Household Income
  const income = userData[PapScreenName.PapHouseholdIncome]?.[0];
  if (income === 'low') {
    score += 2;
  } else if (income === 'mid') {
    score += 1;
  }

  // Q3: Hardship Factors
  const hardshipFactors = userData[PapScreenName.PapHardshipFactors] ?? [];
  for (const factor of hardshipFactors) {
    if (factor !== HARDSHIP_NONE) {
      score += 2;
    }
  }

  // Q4: Affordability
  const affordability = userData[PapScreenName.PapAffordability]?.[0];
  if (affordability === 'maybe') {
    score += 1;
  } else if (affordability === 'no') {
    score += 2;
  }

  const tier = calculatePapTier(score, isNonReferred);
  return { score, tier };
}

export function calculatePapTier(score: number, isNonReferred: boolean): PapTier {
  if (isNonReferred) {
    if (score >= 11) return PapTier.Full;
    if (score >= 9) return PapTier.Moderate;
    return PapTier.Standard;
  }
  if (score >= 9) return PapTier.Full;
  if (score >= 4) return PapTier.Moderate;
  return PapTier.Standard;
}
